var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "kvm-own"
    },
    [
      _c("v-autocomplete", {
        staticClass: "mb-2",
        attrs: {
          items: _vm.domainItems,
          loading: _vm.loading,
          label: "Your domain",
          outlined: "",
          dense: "",
          "persistent-hint": "",
          "no-data-text": _vm.loading
            ? "Loading your domains…"
            : "No domains found in your account",
          hint:
            "A domain in one of your hosting accounts, or registered with us"
        },
        model: {
          value: _vm.domainName,
          callback: function callback($$v) {
            _vm.domainName = $$v
          },
          expression: "domainName"
        }
      }),
      _vm.entry
        ? [
            _c("v-text-field", {
              staticClass: "mb-2",
              attrs: {
                label: "Subdomain",
                outlined: "",
                dense: "",
                "persistent-hint": "",
                suffix: "." + _vm.entry.domain,
                "error-messages": _vm.problem ? [_vm.problem] : [],
                hint: _vm.entry.inHosting
                  ? "Your website keeps " +
                    _vm.entry.domain +
                    " and www." +
                    _vm.entry.domain +
                    "."
                  : "Leave blank to use " + _vm.entry.domain + " itself."
              },
              on: {
                input: function input($event) {
                  _vm.autoSub = false
                }
              },
              model: {
                value: _vm.sub,
                callback: function callback($$v) {
                  _vm.sub = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "sub"
              }
            }),
            _vm.checking
              ? _c(
                  "div",
                  {
                    staticClass: "kvm-own__status kvm-help text-caption mb-2",
                    attrs: {
                      role: "status"
                    }
                  },
                  [
                    _c("v-progress-circular", {
                      staticClass: "mr-2",
                      attrs: {
                        indeterminate: "",
                        size: "14",
                        width: "2",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    }),
                    _vm._v("Checking " + _vm._s(_vm.hostname) + "… ")
                  ],
                  1
                )
              : _vm.route && !_vm.problem
              ? [
                  _vm.conflicts.length
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "kvm-own__alert mb-2",
                          attrs: {
                            type: "warning",
                            dense: "",
                            text: "",
                            role: "alert"
                          }
                        },
                        [
                          _c("strong", [_vm._v(_vm._s(_vm.hostname))]),
                          _vm._v(
                            " already points to " +
                              _vm._s(
                                _vm.conflicts
                                  .map(function(c) {
                                    return (
                                      c.address +
                                      (c.type !== "A"
                                        ? " (".concat(c.type, ")")
                                        : "")
                                    )
                                  })
                                  .join(", ")
                              ) +
                              ". Using it for this app replaces that — whatever it reaches now stops working at this address. "
                          ),
                          _c("v-checkbox", {
                            staticClass: "mt-1",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              label:
                                "Replace it — point " +
                                _vm.hostname +
                                " to this app"
                            },
                            model: {
                              value: _vm.confirmed,
                              callback: function callback($$v) {
                                _vm.confirmed = $$v
                              },
                              expression: "confirmed"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.route.kind !== "manual"
                    ? _c(
                        "p",
                        {
                          staticClass: "kvm-help text-caption mb-2"
                        },
                        [
                          _vm._v(
                            " We'll set " +
                              _vm._s(_vm.hostname) +
                              " up in " +
                              _vm._s(
                                _vm.route.kind === "cpanel"
                                  ? "your hosting account’s DNS"
                                  : "your domain’s DNS"
                              ) +
                              " for you. "
                          )
                        ]
                      )
                    : _c(
                        "p",
                        {
                          staticClass: "kvm-help text-caption mb-2"
                        },
                        [
                          _vm._v(
                            " We can't change DNS for " +
                              _vm._s(_vm.entry.domain) +
                              " from here — point an A record for " +
                              _vm._s(_vm.hostname) +
                              " to "
                          ),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.serverIp || "your server’s IP address")
                            )
                          ]),
                          _vm._v(" (HTTPS starts working once it does). ")
                        ]
                      )
                ]
              : _vm._e(),
            _vm.error
              ? _c(
                  "p",
                  {
                    staticClass: "error--text text-caption mb-2",
                    attrs: {
                      role: "alert"
                    }
                  },
                  [_vm._v(_vm._s(_vm.error))]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }